import React, { useState, useContext, createContext } from "react";

const AppContext = createContext();

const AppProvider = ({ children }) => {
  const [image, setImage] = useState("");
  const [selectedImage, setSelectedImage] = useState(null);

  function uploadImage(event) {
    setImage(window.URL.createObjectURL(event.target.files[0]));
  }

  const handleImageClick = (img) => {
    setSelectedImage(img);
  };

  return (
    <AppContext.Provider
      value={{
        image,
        setImage,
        uploadImage,
        selectedImage,
        handleImageClick,
      }}
    >
      {children}
    </AppContext.Provider>
  );
};

export const useGlobalContext = () => useContext(AppContext);

export { AppContext, AppProvider };